// This function is used to rename data when it's used for the "AboutThis" component for tags; it would be imported into the component where AboutThis/TagsShowMoreLess component is also imported:

export const getTagsData = ({ tags, tagPath, tagPathReplace, type }) => {
    // if no tags, early return:
    if (!tags) {
        return;
    }

    // map over items & create new data object;
    const newDataObject = tags.map(tag => {
        const { slug, name } = tag;

        let tagLink = "";

        if (type === "photos" || type === "icons") {
            tagLink = tagPath.replace(tagPathReplace, slug);
        } else {
            // we shouldnt actually get to this condition; this is just here just in case:
            tagLink = "";
        }

        return {
            slug,
            name,
            url: tagLink
        };
    });

    return newDataObject;
};
